(function () {
  angular.module('app.core.csv-utils', ['binky.core.lodash']);
})();
